 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTML03_DEDICATION from '@/components/xhtml/03_Dedication'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_PREFACE from '@/components/xhtml/05_Preface'
 import XHTML06_PROLOGUE__HULLABALOO from '@/components/xhtml/06_Prologue__Hullabaloo'
 import XHTML07_1__THE_STARS_START_FALLING from '@/components/xhtml/07_1__The_Stars_Start_Falling'
 import XHTML08_2__MAGIC_CLOAK from '@/components/xhtml/08_2__Magic_Cloak'
 import XHTML09_3__LIQUID_FORGET from '@/components/xhtml/09_3__Liquid_Forget'
 import XHTML10_4__VACATION from '@/components/xhtml/10_4__Vacation'
 import XHTML11_5__TEENAGE_BABYLON from '@/components/xhtml/11_5__Teenage_Babylon'
 import XHTML12_6__JUST_DO_IT from '@/components/xhtml/12_6__Just_Do_It'
 import XHTML13_7__GREENBRIAR from '@/components/xhtml/13_7__Greenbriar'
 import XHTML14_8__EARTHQUAKE from '@/components/xhtml/14_8__Earthquake'
 import XHTML15_9__CARNATIONS from '@/components/xhtml/15_9__Carnations'
 import XHTML16_10__CLUBLAND from '@/components/xhtml/16_10__Clubland'
 import XHTML17_11__THROWING_SHAPES from '@/components/xhtml/17_11__Throwing_Shapes'
 import XHTML18_12__VIRTUOSITY from '@/components/xhtml/18_12__Virtuosity'
 import XHTML19_13__RED_HEAD from '@/components/xhtml/19_13__Red_Head'
 import XHTML20_14__NUT_WHITES from '@/components/xhtml/20_14__Nut_Whites'
 import XHTML21_15__TROPICANA from '@/components/xhtml/21_15__Tropicana'
 import XHTML22_16__CHINO_JAM from '@/components/xhtml/22_16__Chino_Jam'
 import XHTML23_17__REGULAR_FORMAT from '@/components/xhtml/23_17__Regular_Format'
 import XHTML24_18__GOOD_MOJO from '@/components/xhtml/24_18__Good_Mojo'
 import XHTML25_19__WILD_JOKERS from '@/components/xhtml/25_19__Wild_Jokers'
 import XHTML26_20__UNFORGIVEN from '@/components/xhtml/26_20__Unforgiven'
 import XHTML27_21__NEXT_TO_MERLE from '@/components/xhtml/27_21__Next_to_Merle'
 import XHTML28_22__BALANCE_THE_BUZZ from '@/components/xhtml/28_22__Balance_the_Buzz'
 import XHTML29_23__LITTLE_SCISSOR from '@/components/xhtml/29_23__Little_Scissor'
 import XHTML30_24__PRIVATE_JET from '@/components/xhtml/30_24__Private_Jet'
 import XHTML31_25__DON_T_LEAVE from '@/components/xhtml/31_25__Don_t_Leave'
 import XHTML32_26__TUTUS_AND_TIARAS from '@/components/xhtml/32_26__Tutus_and_Tiaras'
 import XHTML33_27__BASH_AND_CRASH from '@/components/xhtml/33_27__Bash_and_Crash'
 import XHTML34_28__GIANT_BABY from '@/components/xhtml/34_28__Giant_Baby'
 import XHTML35_29__DIVERSIONS from '@/components/xhtml/35_29__Diversions'
 import XHTML36_30__HELICOPTER from '@/components/xhtml/36_30__Helicopter'
 import XHTML37_31__CONVERTIBLES from '@/components/xhtml/37_31__Convertibles'
 import XHTML38_32__SHRINKING__SINKING from '@/components/xhtml/38_32__Shrinking__Sinking'
 import XHTML39_33__LET_S_HAVE_A_PARTY from '@/components/xhtml/39_33__Let_s_Have_a_Party'
 import XHTML40_34__FALSITY from '@/components/xhtml/40_34__Falsity'
 import XHTML41_35__CAMOUFLAGE from '@/components/xhtml/41_35__Camouflage'
 import XHTML42_36__THE_SAME_UNION from '@/components/xhtml/42_36__The_Same_Union'
 import XHTML43_37__QUEEN_BEES from '@/components/xhtml/43_37__Queen_Bees'
 import XHTML44_38__THE_RIGHT_WAY from '@/components/xhtml/44_38__The_Right_Way'
 import XHTML45_39__GOLD_AND_PLATINUM from '@/components/xhtml/45_39__Gold_and_Platinum'
 import XHTML46_40__CHEERLEADER from '@/components/xhtml/46_40__Cheerleader'
 import XHTML47_41__FRIED_AND_RAW from '@/components/xhtml/47_41__Fried_and_Raw'
 import XHTML48_42__COOKIES from '@/components/xhtml/48_42__Cookies'
 import XHTML49_43__ULTRAS from '@/components/xhtml/49_43__Ultras'
 import XHTML50_44__THINGY_IN_THE_SKY from '@/components/xhtml/50_44__Thingy_in_the_Sky'
 import XHTML51_EPILOGUE_A_GO_GO from '@/components/xhtml/51_Epilogue_a_Go_Go'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML52_ACKNOWLEDGMENTS from '@/components/xhtml/52_Acknowledgments'
 import XHTML53_A_NOTE_ON_SOURCES_AND_IDENTIFICA from '@/components/xhtml/53_A_Note_on_Sources_and_Identifica'
 import XHTML54_INDEX from '@/components/xhtml/54_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Preface",
 			"name" : "xhtml/05_Preface",
 			"component" : XHTML05_PREFACE
 		},
 		{
 			"path" : "/xhtml/06_Prologue__Hullabaloo",
 			"name" : "xhtml/06_Prologue__Hullabaloo",
 			"component" : XHTML06_PROLOGUE__HULLABALOO
 		},
 		{
 			"path" : "/xhtml/07_1__The_Stars_Start_Falling",
 			"name" : "xhtml/07_1__The_Stars_Start_Falling",
 			"component" : XHTML07_1__THE_STARS_START_FALLING
 		},
 		{
 			"path" : "/xhtml/08_2__Magic_Cloak",
 			"name" : "xhtml/08_2__Magic_Cloak",
 			"component" : XHTML08_2__MAGIC_CLOAK
 		},
 		{
 			"path" : "/xhtml/09_3__Liquid_Forget",
 			"name" : "xhtml/09_3__Liquid_Forget",
 			"component" : XHTML09_3__LIQUID_FORGET
 		},
 		{
 			"path" : "/xhtml/10_4__Vacation",
 			"name" : "xhtml/10_4__Vacation",
 			"component" : XHTML10_4__VACATION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js